module.exports = __webpack_public_path__ + "img/hopways-03.5e9780ff.webp";